export default __webpack_public_path__ + "static/media/cp_geo_is.89be1b71.svg";